var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"mediaclip-designer",attrs:{"name":"mediaclip-designer","src":_vm.mediaclipUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }